import { Label, Tooltip, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';

import { Link } from '@/packages/shared-ui';
import { stopPropagation } from '@/packages/utils/event';

import { TooltipContent } from '../../components/TooltipContent';

export const WithAuctionLabelContainer: FC = () => {
  const { config } = useListingAppContext();

  const legalDocsUrl = config.getStrict<string>('electronicTrading.legalDocsUrl');

  return (
    <Tooltip
      arrow={false}
      placement="bottom"
      theme="white"
      title={
        <TooltipContent testId="electronic-trading.tooltip">
          <UIText2>
            Объект реализуется через проведение <br />
            торгов в соответствии с ГК РФ
          </UIText2>
          <UIText2 color="accent-main-primary">
            <Link behaviour="hover_primary_to_primary_hover" href={legalDocsUrl} onClick={stopPropagation}>
              Справочная информация
            </Link>
          </UIText2>
        </TooltipContent>
      }
    >
      <Label background="overlay-control-dark" color="decorative-theme-black" data-testid="publisher-labels.auction">
        Аукцион
      </Label>
    </Tooltip>
  );
};
